// TODO move to core (or another solution to allow for auto-focus only on non-touch screens)

export function isTouchScreen() {
	try {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	} catch {
		return false;
	}
}
